// @core/api/endpoints/workflow/sync_product_pipelines.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SyncProductPipelinesRequest,
  SyncProductPipelinesResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Sync product pipelines
 * Checks installed product pipelines against their source templates. Returns available updates. Does NOT auto-apply — tenant admin reviews and accepts each update.
 */
export async function SyncProductPipelines(
  data: SyncProductPipelinesRequest,
  options?: RequestOptions
): Promise<SyncProductPipelinesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/templates/sync-product`;
  const requestOptions = options;
  return client.post<SyncProductPipelinesResponse>(requestPath, data, requestOptions);
}
